import React from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  ChevronRightIcon,
  Center,
  Pressable,
} from 'native-base';
import {IDebtorItem} from '../../../../../interfaces/dtos';
import {DollarIcon} from '../../../../../components/icons';

interface CustomProps {
  onPress: () => void;
  rowType: 'odd' | 'even';
}

type ItemProps = CustomProps & IDebtorItem;

const DebtorItem = (props: ItemProps) => {
  const {client, amount, onPress, rowType} = props;

  const handleOnPress = () => {
    onPress();
  };

  const getStripedColor = () => {
    if (rowType === 'odd') {
      return '#FFFFFF';
    }
    return '#F3F9FF';
  };

  return (
    <Pressable onPress={() => handleOnPress()}>
      <HStack
        width="100%"
        backgroundColor={getStripedColor()}
        paddingY={3}
        paddingX={5}>
        <VStack flex={1}>
          <HStack space={5}>
            <VStack justifyContent="center" space="0" flex={1}>
              <Box
                height="5"
                justifyContent="center"
                marginTop={1}
                paddingLeft={1}>
                <Text
                  color="#06355E"
                  fontSize={'14'}
                  ellipsizeMode="tail"
                  numberOfLines={1}>
                  {client}
                </Text>
              </Box>
            </VStack>
            <HStack w="100">
              <VStack justifyContent="center" space="1">
                <Box height="5" justifyContent="center">
                  <DollarIcon />
                </Box>
              </VStack>
              <VStack justifyContent="flex-end" space="1" w={'85'}>
                <Box height="5" alignItems={'flex-end'} paddingLeft="2">
                  <Text fontWeight="bold" color="#06355E" fontSize={'14'}>
                    {amount}
                  </Text>
                </Box>
              </VStack>
            </HStack>
          </HStack>
        </VStack>
        <Box>
          <Center flex={1} paddingLeft={2}>
            <ChevronRightIcon size="5" color="blue.500" />
          </Center>
        </Box>
      </HStack>
    </Pressable>
  );
};

export default DebtorItem;
